import { memo as Memo, useMemo, useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';

//* Components
import Text from '@/components/global/Text';
import Game from '@components/pages/AboutUs/Game';
import TableItem from '@components/global/TableItem';

//* Styles
import TopSectionStyle from './style';

const TopSection = Memo(({ active, ...data }) => {
	//! Refs
	const containerRef = useRef();
	const topRef1 = useRef();
	const topRef2 = useRef();
	const topRef3 = useRef();
	const topRef4 = useRef();

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.3 }), []);

	useLayoutEffect(() => {
		if (!topRef1.current || !topRef2.current || !topRef3.current || !topRef4.current) return;

		const ctx = gsap.context(() => {
			const targets = [...(topRef1.current.children || []), ...(topRef2.current.children || []), topRef3.current, topRef4.current].filter(Boolean);

			tl.clear().to(targets, { opacity: 1, duration: 0, stagger: 0.2 }).to(topRef2.current.children, { fontStyle: 'italic', duration: 0, stagger: 0.15 });
		}, containerRef);

		tl.play();

		return () => {
			ctx.revert();
			tl.kill();
		};
	}, [tl]);

	return (
		<TopSectionStyle ref={containerRef}>
			<div className={`topWrap section-item crHide`}>
				<Game />

				<div className={'titleWrap'}>
					<Text
						tag={'h1'}
						ref={topRef1}
						className={`h1 font-poppins font-medium title`}>
						<Text tag={'span'}>{data.title.first}</Text>
						<Text tag={'span'}>{data.title.second}</Text>
					</Text>
				</div>

				<div className={'subtitleWrap'}>
					<Text
						tag={'h2'}
						ref={topRef2}
						className={`h2 font-poppins font-light subtitle`}>
						<Text tag={'span'}>{data.subtitle.first}</Text>
						<Text tag={'span'}>{data.subtitle.second}</Text>
					</Text>
				</div>

				<div
					ref={topRef3}
					className={'secondIconCont'}></div>
			</div>

			<div
				ref={topRef4}
				className={'descriptionWrap'}>
				<Text className={`h5 font-poppins font-light description`}>{data.description}</Text>
			</div>

			<div>
				<TableItem
					active={active}
					minWidth
					underline
					className={'one-item'}
					title={data.sub_article.title}
					description={data.sub_article.description}
				/>
			</div>
		</TopSectionStyle>
	);
});

export default TopSection;
